import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const StyledContainer = styled.div`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  margin: 20px;
  display: flex;
  gap: 20px;
  flex-direction: column;
`;

export const StyledHeader = styled.div`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleDisplayMedium
      : textStyleCss(theme.atlas.typography.semantic.headingH3)};
`;

export const StyledSubHeader = styled.div`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBodySemibold
      : textStyleCss(theme.atlas.typography.semantic.body)};
  ${({ theme }) => !theme.isVaultVariant && 'font-weight: 600;'}
  margin-bottom: 10px;
`;

export const StyledSubDescription = styled.div`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted};
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.body)};
`;

export const StyledSubSection = styled.div`
  display: flex;
  justify-content: space-between;

  @media screen and (min-width: 0px) and (max-width: 900px) {
    flex-direction: column;
    gap: 40px;
  }
`;

export const DividerContainer = styled.div`
  padding: 0 20px;
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  flex: 3;
  margin-right: 20px;

  @media screen and (min-width: 0px) and (max-width: 900px) {
    max-width: 100%;
  }
`;

export const RightSide = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;

  @media screen and (min-width: 0px) and (max-width: 900px) {
    max-width: 100%;
    justify-content: flex-start;
  }
`;
